/** postMessage payload from DigiLocker return tab back to the loan-application tab. */
export const DIGILOCKER_KYC_CALLBACK_MESSAGE = 'los:digilocker-kyc-callback';

export const DIGILOCKER_OPENER_ORIGIN_STORAGE_KEY =
  'los:digilocker-kyc:openerOrigin';

export type DigilockerKycCallbackPayload = {
  type: typeof DIGILOCKER_KYC_CALLBACK_MESSAGE;
  status: 'success';
};

export function isDigilockerKycCallbackPayload(
  data: unknown,
): data is DigilockerKycCallbackPayload {
  if (!data || typeof data !== 'object') {
    return false;
  }
  const record = data as Record<string, unknown>;
  return (
    record['type'] === DIGILOCKER_KYC_CALLBACK_MESSAGE &&
    record['status'] === 'success'
  );
}
